import { render, staticRenderFns } from "./bottomCom.vue?vue&type=template&id=313284b4&scoped=true"
import script from "./bottomCom.vue?vue&type=script&lang=js"
export * from "./bottomCom.vue?vue&type=script&lang=js"
import style0 from "./bottomCom.vue?vue&type=style&index=0&id=313284b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313284b4",
  null
  
)

export default component.exports